var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85131 3.75H2.50006V2.5H6.87506L7.50006 3.125V7.5H6.25006V5C5.12971 5.84061 4.3242 7.03317 3.96274 8.38638C3.60129 9.73958 3.70486 11.175 4.25682 12.4623C4.80879 13.7496 5.77716 14.8141 7.00658 15.4852C8.236 16.1563 9.65519 16.3949 11.0365 16.1629C12.4178 15.9309 13.6811 15.2416 14.6237 14.2056C15.5664 13.1696 16.1337 11.8471 16.2348 10.4501C16.3358 9.05308 15.9646 7.66264 15.1809 6.50183C14.3971 5.34102 13.2461 4.47713 11.9126 4.04875L12.2901 2.85625C13.9083 3.37516 15.3024 4.42828 16.2439 5.8431C17.1854 7.25791 17.6184 8.95053 17.4722 10.6437C17.3259 12.3368 16.6089 13.93 15.4387 15.1624C14.2685 16.3948 12.7145 17.1932 11.0312 17.4268C9.34787 17.6605 7.63513 17.3155 6.17351 16.4485C4.7119 15.5814 3.58808 14.2437 2.98618 12.6544C2.38427 11.0652 2.33995 9.31858 2.86049 7.70082C3.38102 6.08307 4.43555 4.69006 5.85131 3.75Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatReload);
export default __webpack_public_path__ + "static/media/chatReload.4a940707bffdce4ec5a3549e5e3cf313.svg";
export { ForwardRef as ReactComponent };